import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Gallery from "@/views/Gallery";
import GalleryCategory from "@/views/GalleryCategory";

Vue.use(VueRouter)

const routes = [
    {
      path: '/',
      redirect: '/home'
    },
    {
        path: '/home',
        name: 'Home',
        component: Home
    },
    {
        path: '/gallery',
        name: "Gallery",
        component: Gallery
    },
    {
        path: '/gallery/:category',
        name: 'GalleryCategory',
        component: GalleryCategory
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
